enum EstadosModalArchivoPDF {
    CERRADO = 'CERRADO',
    VISUALIZACION = 'VISUALIZACION',
}

export { EstadosModalArchivoPDF };
